"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _system = require("@mui/system");

var _daDesignSystem = require("@docaposte-agility/da-design-system/");

var _excluded = ["backIconButtonProps", "count", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "className", "showFirstButton", "showLastButton", "getItemAriaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Actions = (0, _system.styled)('div')(function (_ref) {
  var _theme$components, _theme$components$Mui, _theme$components$Mui2;

  var theme = _ref.theme;
  return _objectSpread({}, (theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$Mui = _theme$components.MuiTablePagination) === null || _theme$components$Mui === void 0 ? void 0 : (_theme$components$Mui2 = _theme$components$Mui.styleOverrides) === null || _theme$components$Mui2 === void 0 ? void 0 : _theme$components$Mui2.actions) || {});
});

var TablePaginationActions = function TablePaginationActions(props) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      onPageChange = props.onPageChange,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      className = props.className,
      showFirstButton = props.showFirstButton,
      showLastButton = props.showLastButton,
      getItemAriaLabel = props.getItemAriaLabel,
      others = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Actions, others, showFirstButton && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    disabled: page === 0,
    onClick: function onClick(event) {
      return onPageChange(event, 0);
    },
    title: "Premi\xE8re page",
    size: "small",
    sx: {
      mr: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_daDesignSystem.CobaltIcon, {
    name: "chevrons-left"
  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    color: "inherit",
    disabled: page === 0,
    onClick: function onClick(event) {
      return onPageChange(event, page - 1);
    }
  }, backIconButtonProps, {
    size: "small",
    sx: {
      mr: 1
    }
  }), /*#__PURE__*/_react["default"].createElement(_daDesignSystem.CobaltIcon, {
    name: "chevron-left"
  })), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    component: "span"
  }, "Page ", page + 1, " sur ", Math.ceil(count / rowsPerPage)), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    color: "inherit",
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    onClick: function onClick(event) {
      return onPageChange(event, page + 1);
    }
  }, nextIconButtonProps, {
    size: "small",
    sx: {
      mx: 1
    }
  }), /*#__PURE__*/_react["default"].createElement(_daDesignSystem.CobaltIcon, {
    name: "chevron-right"
  })), showLastButton && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    onClick: function onClick(event) {
      return onPageChange(event, Math.ceil(count / rowsPerPage - 1));
    },
    title: "Derni\xE8re page",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_daDesignSystem.CobaltIcon, {
    name: "chevrons-right"
  })));
};

var _default = TablePaginationActions;
exports["default"] = _default;